/**
 * Created by Administrador on 13/01/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('flightTypeTaxService', flightTypeTaxService);

    flightTypeTaxService.$inject = ['$http', 'CONFIG', 'messageService'];

    function flightTypeTaxService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/flightTypeTaxTypes';
        var service = {
            getFlightTypeTax: getFlightTypeTax
        }

        return service;

        function getFlightTypeTax(){
            return $http.get(urlBase)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    };
})();
